import React, { useState, useContext, useEffect } from 'react'
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet'
import FlexView from 'react-flexview/lib'
import { GreenButton } from '../Core/Buttons/GreenButton'
import { Collapse, Grid, useMediaQuery } from '@material-ui/core'
import { useLocation } from 'react-router-dom'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import { liabilityLimitPretty, billingPeriodPretty, isInFlow, KPretty, currencySymbol, CentPretty } from '../../services/utils'
import { billing_period_options, flowType, PAYMENT_FEE } from '../../Constants'
import { isMobile } from 'react-device-detect'
import { SessionContextStore } from '../../context/SessionContext'
import { reportGTM } from '../Core/Utilities/GTagManger'
import { StatesContextStore } from '../../context/StatesContext'
import { isToday } from 'date-fns'

export const BottomSheetPolicySummary = ({ shouldShowButton = true, ...props }) => {
  const [policySummaryOpenMobile, setPolicySummaryOpenMobile] = useState(false)
  const offersContext = useContext(BuyingInsuranceContextStore)
  const sessionContext = useContext(SessionContextStore)
  const statesContext = React.useContext(StatesContextStore)
  const location = useLocation()
  const [showOverflowTop, setShowOverflowTop] = useState(false)
  const isMobileByWidth = !useMediaQuery(theme => theme.breakpoints.up('md'))
  const [policyDate, setPolicyDate] = useState('')
  const isNewFlow = sessionContext.newPaymentFlow
  let additionalFees = offersContext.pricebreakdown.additionalFees
  const minimumEarnedPremium = offersContext.pricebreakdown.minimumEarnedPremium
  let initialPerMileCharge =
    offersContext.billingFlowType === flowType.ESTIMATED_MILEAGE
      ? offersContext.pricebreakdown.totalEstimatedMileageCharge
      : offersContext.pricebreakdown.totalBaseMilesCharge

  const paymentFee = statesContext.no_initial_payment_fee.includes(sessionContext.user.administrativeDivision) ? 0 : PAYMENT_FEE
  let addOnPrice = 0
  if (offersContext.pricebreakdown.addOnCoveragePrices) {
    offersContext.pricebreakdown.addOnCoveragePrices.forEach(x => (addOnPrice += x.fixedPrice))
  }
  let total =
    initialPerMileCharge + paymentFee + offersContext.pricebreakdown.fixedPrice + additionalFees + addOnPrice + minimumEarnedPremium
  if (!sessionContext.newPaymentFlow) {
    total = offersContext.pricebreakdown.fixedPrice + paymentFee + additionalFees + minimumEarnedPremium
  }

  const isPolicyStartingToday = isToday(offersContext.subscriptionStartTime)
  const toggleBottomSheet = () => {
    setPolicySummaryOpenMobile(!policySummaryOpenMobile)
  }

  const openBottomSheet = open => {
    setPolicySummaryOpenMobile(open)
  }

  const onGreenButtonClick = e => {
    reportGTM('', '', { event: 'Continue-button-at-summary' })
    e.stopPropagation()
    props.onClick()
  }

  const onTransitionEnd = () => {
    setShowOverflowTop(policySummaryOpenMobile)
  }

  useEffect(() => {}, [offersContext.subscriptionStartTime])

  return (
    <SwipeableBottomSheet
      style={{ zIndex: 100000000 }}
      swipeableViewsProps={{ onTransitionEnd: onTransitionEnd }}
      open={policySummaryOpenMobile}
      onChange={openBottomSheet}
      shadowTip={false}
      overflowHeight={isMobileByWidth ? 80 : 96}
      className="signature-footer"
    >
      <Collapse in={!showOverflowTop}>
        {offersContext.pricebreakdown && offersContext.pricebreakdown.fixedPrice && offersContext.pricebreakdown.perMileCharge ? (
          location.pathname.includes('credit-card') ? (
            <div onClick={toggleBottomSheet} style={{ height: 64, padding: isMobileByWidth ? 0 : 6, marginLeft: 55, marginTop: 15 }}>
              <FlexView vAlignContent={'center'} hAlignContent={'right'} className="space-between margin-top-small">
                <div className="auto-horizontal-margin">
                  <FlexView>
                    <FlexView vAlignContent={'center'} className="auto-horizontal-margin text-style-bottom-summary black bold">
                      {currencySymbol()}
                      {total.toFixed(2)} Today{' '}
                    </FlexView>
                  </FlexView>
                </div>
                <GreenButton
                  style={{ display: shouldShowButton ? 'block' : 'none' }}
                  className="payment-newFlow-button-mobile"
                  disabled={Object.keys(offersContext.offerCardErrors).length > 0}
                  onClick={onGreenButtonClick}
                >
                  Buy Policy
                </GreenButton>
              </FlexView>
            </div>
          ) : (
            <>
              <div onClick={toggleBottomSheet} style={{ height: 64, padding: isMobileByWidth ? 0 : 6, marginTop: 15 }}>
                <FlexView vAlignContent={'center'} hAlignContent={'right'} className="space-between margin-top-small">
                  <div className="auto-horizontal-margin">
                    <FlexView column>
                      <FlexView vAlignContent={'center'} hAlignContent={'left'} className="black bold avenir-book margin-bottom-small">
                        {isPolicyStartingToday ? (
                          <span className="text-title">
                            Due Today {currencySymbol()}
                            {total.toFixed(2)}
                          </span>
                        ) : (
                          <span className="text-body">
                            Due on{' '}
                            {offersContext.subscriptionStartTime.toLocaleDateString('en-US', {
                              year: '2-digit',
                              month: '2-digit',
                              day: '2-digit',
                            })}{' '}
                            {currencySymbol()}
                            {total.toFixed(2)}
                          </span>
                        )}
                      </FlexView>
                      <FlexView vAlignContent={'center'} hAlignContent={'left'} className="black avenir-book text-small">
                        Monthly: {currencySymbol()}
                        {offersContext.pricebreakdown.monthlyFixedPrice.toFixed(2)} +{' '}
                        <span className="margin-left-3 margin-right-3">{CentPretty(offersContext.pricebreakdown.perMileCharge)}</span> /
                        mile
                      </FlexView>
                    </FlexView>
                  </div>
                  <GreenButton
                    style={{ display: shouldShowButton ? 'block' : 'none' }}
                    className="continue-button-mobile"
                    disabled={Object.keys(offersContext.offerCardErrors).length > 0}
                    onClick={onGreenButtonClick}
                  >
                    {props.title}
                  </GreenButton>
                </FlexView>
              </div>
            </>
          )
        ) : (
          !offersContext.offerId &&
          location.pathname.includes('summary') && (
            <>
              <div onClick={toggleBottomSheet} style={{ height: 64, padding: isMobileByWidth ? 0 : 6, marginTop: 15 }}>
                <FlexView vAlignContent={'center'} hAlignContent={'right'} className="space-between margin-top-small">
                  <div className="auto-horizontal-margin">
                    <FlexView column>
                      <FlexView vAlignContent={'center'} hAlignContent={'left'} className="black bold avenir-book margin-left-basic">
                        Monthly: {currencySymbol()}
                        {offersContext.plans.items[0].fixedPrice.toFixed(2)} +{' '}
                        <span className="margin-left-3 margin-right-3">{CentPretty(offersContext.plans.items[0].perMileCharge)}</span> /
                        mile
                      </FlexView>
                    </FlexView>
                  </div>
                  <GreenButton
                    style={{ display: shouldShowButton ? 'block' : 'none' }}
                    className="continue-button-mobile"
                    disabled={Object.keys(offersContext.offerCardErrors).length > 0}
                    onClick={onGreenButtonClick}
                  >
                    {props.title}
                  </GreenButton>
                </FlexView>
              </div>
            </>
          )
        )}
      </Collapse>
    </SwipeableBottomSheet>
  )
}
